import api from '@/api'
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import PasswordValidation from '@/components/elements/PasswordValidation'

export default {
  props: ['value', 'type'],
  data() {
    return {
      showAdminStartTimeDialog: false,
      showAdminEndTimeDialog: false,
      loadingUser: false,
      subgroupKey: 1,
      user: {
        userid: null,
        password: null,
        group: null,
        subgroup: null
        // adminstarttime: null,
        // adminendtime: null
      },
      privilege: {
        role: ''
      },
      general_permission: {
        admin_user_management: false,
        seminar_management: false,
        chatbot_management: false,
        member_management: false
      },
      broadcast_permission: {
        create_broadcast: false,
        view_create_broadcast: null,
        approve_broadcast: false,
        view_approve_broadcast: null
      },

      permissionCreateBroadcastOptions: [
        { label: 'Only me (เห็นเฉพาะข้อมูลที่ตัวเองสร้าง)', value: 'only_me' },
        { label: 'Only group (เห็นเฉพาะข้อมูลที่กลุ่มเดียวกันสร้าง)', value: 'only_group' },
        { label: 'All (เห็นข้อมูลทั้งหมด)', value: 'all' }
      ],
      permissionApproveBroadcastOptions: [
        { label: 'Only group (เห็นเฉพาะข้อมูลที่กลุ่มเดียวกันสร้าง)', value: 'only_group' },
        { label: 'All (เห็นข้อมูลทั้งหมด)', value: 'all' }
      ],
      isValidPassword: false
    }
  },
  components: {
    Multiselect,
    PasswordValidation
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      agentGroup: 'getAgentGroup',
      loadingAgentGroup: 'getLoadingAgentGroup',
      agents: 'getAgent',
      loadingAgent: 'getLoadingAgent'
    })
  },
  watch: {
    value: {
      handler() {
        this.handleInitial()
      }
    }
  },
  mounted() {
    this.handleInitial()
  },
  methods: {
    handleInitial() {
      const vm = this
      if (vm.value) {
        vm.user = {
          userid: vm.value.adminid
        }

        if (vm.value.admingroupid) {
          const group = vm.agentGroup.find((el) => {
            return el.id == vm.value.admingroupid
          })
          vm.$set(vm.user, 'group', group)
        }

        try {
          if (vm.value.privilege) {
            const tempPrivilege = JSON.parse(vm.value.privilege)

            vm.general_permission = tempPrivilege.general_permission
            const viewPermissionCreateBroadcast = vm.permissionCreateBroadcastOptions.find(
              (item) => item.value === tempPrivilege.broadcast_permission.view_create_broadcast
            )

            const viewPermissionApproveBroadcast = vm.permissionApproveBroadcastOptions.find(
              (item) => item.value === tempPrivilege.broadcast_permission.view_approve_broadcast
            )

            vm.broadcast_permission.create_broadcast =
              tempPrivilege.broadcast_permission.create_broadcast
            vm.broadcast_permission.approve_broadcast =
              tempPrivilege.broadcast_permission.approve_broadcast
            vm.broadcast_permission.view_create_broadcast = viewPermissionCreateBroadcast
            vm.broadcast_permission.view_approve_broadcast = viewPermissionApproveBroadcast
          } else {
            vm.general_permission = {
              admin_user_management: false,
              seminar_management: false,
              chatbot_management: false,
              member_management: false
            }
            vm.broadcast_permission = {
              create_broadcast: false,
              view_create_broadcast: null,
              approve_broadcast: false,
              view_approve_broadcast: null
            }
          }
        } catch (error) {
          vm.general_permission = {
            admin_user_management: false,
            seminar_management: false,
            chatbot_management: false,
            member_management: false
          }
          vm.broadcast_permission = {
            create_broadcast: false,
            view_create_broadcast: null,
            approve_broadcast: false,
            view_approve_broadcast: null
          }
        }
      }

      vm.cached_user = JSON.stringify(vm.user)
      vm.cached_privilege = JSON.stringify(vm.transfromPrivilegeData())
    },
    createAdminUser(data) {
      return new Promise((resolve, reject) => {
        api.createadminuser(data, (error, response) => {
          if (error) {
            reject(error)
          }
          if (response) {
            resolve(response)
          }
        })
      })
    },
    changePrivilegeAdminUser(data) {
      return new Promise((resolve, reject) => {
        api.changeprivilegeadminuser({ data: data }, (error, response) => {
          if (error) {
            reject(error)
          }

          if (response) {
            resolve(response)
          }
        })
      })
    },
    transfromPrivilegeData() {
      const data = {}
      Object.assign(data, { general_permission: this.general_permission })
      Object.assign(data, {
        broadcast_permission: {
          create_broadcast: this.broadcast_permission.create_broadcast,
          view_create_broadcast: this.broadcast_permission.view_create_broadcast
            ? this.broadcast_permission.view_create_broadcast.value
            : null,
          approve_broadcast: this.broadcast_permission.approve_broadcast,
          view_approve_broadcast: this.broadcast_permission.view_approve_broadcast
            ? this.broadcast_permission.view_approve_broadcast.value
            : null
        }
      })

      return data
    },
    async onSave() {
      const vm = this
      try {
        const result = await vm.$validator.validateAll()
        if (!result) {
          vm.goToErrorInput()
          return false
        }

        const privilege = vm.transfromPrivilegeData()

        let data = {
          userid: vm.user.userid,
          password: vm.user.password,
          pageid: vm.selectedBot.pageid,
          privilege: JSON.stringify(privilege),
          admingroupid: vm.user.group ? vm.user.group.id : null,
          adminsubgroupid: null
        }

        let responseUser = null
        if (vm.type == 'add') {
          vm.$store.dispatch('loading')
          responseUser = await vm.createAdminUser(data)
          vm.$store.commit('CLEAR_LOADING')

          if (responseUser) {
            vm.$emit('onSave')
          }
        } else {
          vm.$store.dispatch('loading')
          responseUser = await vm.changePrivilegeAdminUser(data)
          vm.$store.commit('CLEAR_LOADING')

          if (vm.user.userid == vm.$store.state.userid) {
            vm.$swal
              .fire({
                text: 'เข้าสู่ระบบใหม่อีกครั้งเพื่อเปลี่ยนแปลงข้อมูล'
              })
              .then(async () => {
                await vm.$store.dispatch('logout')
                const isFacebook = vm.$store.state.isFacebook
                if (
                  vm.$router.history.current.name != 'login' ||
                  vm.$router.history.current.name != 'nigol'
                ) {
                  if (isFacebook) {
                    vm.$router.push('/login')
                  } else {
                    vm.$router.push('/nigol')
                  }
                }
              })
          }

          if (responseUser) {
            vm.$emit('onSave')
          }
        }

        vm.cached_user = JSON.stringify(vm.user)
        vm.cached_privilege = JSON.stringify(vm.privilege)
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        console.log(error.message)
        vm.$swal.fire({ text: error.message })
      }
    },
    handleClose() {
      this.user = {
        userid: null,
        password: null,
        group: null,
        subgroup: null
      }

      this.general_permission = {
        admin_user_management: false,
        seminar_management: false,
        chatbot_management: false,
        member_management: false
      }
      this.broadcast_permission = {
        create_broadcast: false,
        view_create_broadcast: null,
        approve_broadcast: false,
        view_approve_broadcast: null
      }

      this.$emit('close')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/view/template/Aira/AgentManagement/ManageUser.js